import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icw-documents__clip0_4055_2705)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4h12V2H5c-.53043 0-1.03914.21071-1.41421.58579C3.21071 2.96086 3 3.46957 3 4v14h2V4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6H9c-.53043 0-1.03914.21071-1.41421.58579C7.21071 6.96086 7 7.46957 7 8v12c0 .5304.21071 1.0391.58579 1.4142C7.96086 21.7893 8.46957 22 9 22h10c.5304 0 1.0391-.2107 1.4142-.5858S21 20.5304 21 20V8c0-.53043-.2107-1.03914-.5858-1.41421C20.0391 6.21071 19.5304 6 19 6zm-9 3h6v2h-6V9zm8 10h-8v-2h8v2zm0-4h-8v-2h8v2z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icw-documents__clip0_4055_2705"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "translate(3 2)",
    d: "M0 0h18v19.95H0z"
  }))));
});